// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-normal-item-section .align-expansion-icon-left .v-expansion-panel-header__icon .v-icon{left:1px;margin-top:2px}.menu-normal-item-section .align-expansion-icon-left.expand-arrow-center-aligned .v-expansion-panel-header__icon .v-icon{left:1px;margin-top:2px;top:50%!important;transform:translate(-50%,-50%)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
